var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container-fluid"},[_c('div',{staticClass:"bg-white br-4 p-2"},[_c('h4',{staticClass:"display-6"},[_c('i',{staticClass:"fas fa-lock mr-3"}),_vm._v("Fehlende Berechtigungen ")]),_c('p',{staticClass:"lead"},[_vm._v("Der angeforderte Bereich ist geschützt und Sie besitzen nicht die Rechte, diesen zu Besuchen.")])])])
}]

export { render, staticRenderFns }